/**
 * 계정 잠금 안내 배너.
 * Figma「14 계정 상세 — 잠금 해제」(12679:5172) LockBanner.
 */
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/utils';
import { TriangleAlert } from 'lucide-react';
import React from 'react';

type AccountLockedBannerProps = {
  message: string;
  className?: string;
  onViewActivityLog?: () => void;
};

export const AccountLockedBanner: React.FC<AccountLockedBannerProps> = ({
  message,
  className,
  onViewActivityLog,
}) => (
  <div
    role="alert"
    className={cn(
      'flex w-full flex-wrap items-center justify-between gap-3 rounded-12 bg-ruda-error-50 px-4 py-3 text-ruda-error',
      className,
    )}
  >
    <div className="flex min-w-0 items-start gap-2 text-[13px] font-medium leading-normal">
      <TriangleAlert className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
      <p>{message}</p>
    </div>
    {onViewActivityLog ? (
      <Button
        type="button"
        variant="link"
        size="sm"
        className="h-auto shrink-0 px-0 text-xs text-ruda-error"
        onClick={onViewActivityLog}
      >
        활동 로그 보기 ›
      </Button>
    ) : null}
  </div>
);
